import { WithDialog } from '@kinderlabs-pos/ui-atoms';
import {
	Button,
	DialogActions,
	DialogContent,
	InputLabel,
	OutlinedInput,
	Stack,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

export type ReceiptChoice = '전자' | '일반' | '둘다' | '없음';

interface ReceiptTypeSelectionDialogProps {
	open: boolean;
	defaultPhoneNumber?: string;
	onConfirm: (choice: ReceiptChoice, phoneNumber?: string) => void;
	onClose: () => void;
}

const CHOICES: { value: ReceiptChoice; label: string }[] = [
	{ value: '전자', label: '전자 영수증' },
	{ value: '일반', label: '일반 영수증' },
	{ value: '둘다', label: '둘 다' },
	{ value: '없음', label: '발행 안 함' },
];

export const ReceiptTypeSelectionDialog: React.FC<ReceiptTypeSelectionDialogProps> = ({
	open,
	defaultPhoneNumber,
	onConfirm,
	onClose,
}) => {
	const [choice, setChoice] = useState<ReceiptChoice | null>(null);
	const [phoneNumber, setPhoneNumber] = useState(defaultPhoneNumber ?? '');

	useEffect(() => {
		if (open) {
			setChoice(null);
			setPhoneNumber(defaultPhoneNumber ?? '');
		}
	}, [open]);

	const needsPhone = choice === '전자' || choice === '둘다';
	const confirmDisabled = !choice || (needsPhone && !phoneNumber.trim());

	const handleConfirm = () => {
		if (!choice) return;
		onConfirm(choice, needsPhone ? phoneNumber : undefined);
	};

	return (
		<WithDialog.XlDialog
			open={open}
			closeDialog={onClose}
			dialogTitle={'영수증 발행 방식을 선택해주세요'}>
			<DialogContent>
				<Stack
					spacing={1}
					minWidth={320}>
					{CHOICES.map((c) => (
						<Button
							key={c.value}
							sx={{
								height: 56,
								opacity: choice === c.value ? 1 : 0.35,
								justifyContent: 'flex-start',
								px: 3,
							}}
							color={choice === c.value ? 'primary' : 'inherit'}
							variant={choice === c.value ? 'contained' : 'outlined'}
							onClick={() => setChoice(c.value)}>
							<Typography variant={'h4'}>{c.label}</Typography>
						</Button>
					))}
					{needsPhone && (
						<Stack
							spacing={0.5}
							mt={1}>
							<InputLabel>전화번호</InputLabel>
							<OutlinedInput
								size={'small'}
								value={phoneNumber}
								onChange={(e) => setPhoneNumber(e.target.value)}
								placeholder={'01012345678'}
							/>
						</Stack>
					)}
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button
					variant={'outlined'}
					onClick={onClose}>
					닫기
				</Button>
				<Button
					variant={'contained'}
					disabled={confirmDisabled}
					onClick={handleConfirm}>
					확인
				</Button>
			</DialogActions>
		</WithDialog.XlDialog>
	);
};
